import { Box, IconButton, useTheme } from '@mui/material';
import { tokens } from '../../../../theme';
import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { UserContext } from '../../../../context/UserContext';
import { DataGrid } from '@mui/x-data-grid';
import Header from '../../../../components/Header';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import { useNavigate } from 'react-router';


function CouponOwners() {
    const navigate = useNavigate();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { token } = useContext(UserContext);
    const adId = window.location.pathname.split("/")[window.location.pathname.split("/").length - 1];

    const [ad, setAd] = useState(null);
    const [coupons, setCoupons] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [orderModel, setOrderModel] = useState(null);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 25
    });

    const columns = [
        { field: 'id', headerName: 'ID' },
        { field: 'profile_photo_link', headerName: "Profil Fotoğrafı", sortable: false, renderCell: (params) => <img src={params.value} alt='profile-pic' style={{ height: "30px", width: "30px" }} />, width: 70 },
        {
            field: 'username',
            headerName: 'Kullanıcı Adı',
            flex: 1,
        }, {
            field: 'points', headerName: 'Puan (Süre Bazlı)', flex: 1,
        }, {
            field: 'seconds', headerName: 'Tamamlama Süresi (Saniye)', flex: 1,
        }, {
            field: 'extra_collected_ap', headerName: 'Ekstra Kazanılan AP', flex: 1,
        }, {
            field: "created_date", headerName: "Alınma Tarihi", flex: 1,
            renderCell: ({ row: { created_date } }) => {
                return new Date(created_date).toLocaleDateString() + " " + new Date(created_date).toLocaleTimeString();
            }
        }
    ];

    useEffect(() => {
        fetchAdData();
    }, []);

    useEffect(() => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL}api/alcago/coupon/getOwnedCouponsWithAdId?startIndex=${paginationModel.pageSize * paginationModel.page}&limit=${paginationModel.pageSize}${orderModel ? `&orderField=${orderModel.field}&orderType=${orderModel.sort}` : ""}&token=${token}&adId=${adId}`)
            .catch((err) => {
                setCoupons([]);
                console.log("err: " + err);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 200) {
                    setCoupons(response.data.coupons);
                    setRowCount((prevRowCount) => response.data.rowCount !== undefined ? response.data.rowCount : prevRowCount);
                }
                setLoading(false);
            });
    }, [paginationModel]);

    const fetchAdData = () => {
        axios.get(`${process.env.REACT_APP_API_URL}api/alcago/ad/getAdDetails?token=${token}&id=${adId}`)
            .catch((err) => {
                console.log("err: " + err);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 200) {
                    if (response.data.ad) {
                        setAd(response.data.ad);
                    }
                }
            });
    }

    if (!ad) {
        return <Box>Yükleniyor...</Box>
    }

    return (
        <Box>
            <Box display="flex">
                <IconButton style={{ width: "40px", height: "40px", marginRight: "5px" }}
                    onClick={() => {
                        navigate("/admin-panel/ads");
                    }}>
                    <ArrowBackIosNewOutlinedIcon />
                </IconButton>
                <Box display="flex" mr="5px">
                    <img
                        alt="ad-thumbnail"
                        src={ad.thumbnail_image_link}
                        width="40px"
                        height="40px"
                        style={{ cursor: "pointer", borderRadius: "50%" }} />
                </Box>
                <Box ml={"20px"}>
                    <Header title={ad.coupon_title} subtitle={""} />
                </Box>
            </Box>
            <Box padding="20px" height="80vh">
                <DataGrid
                    rows={coupons}
                    columns={columns}
                    rowCount={rowCount}
                    loading={loading}
                    page={paginationModel.page}
                    pageSize={paginationModel.pageSize}
                    rowsPerPageOptions={[25, 50, 100]}
                    paginationMode="server"
                    onPageChange={(page) => {
                        setPaginationModel((prev) => ({ ...prev, page }))
                    }}
                    onPageSizeChange={(pageSize) => {
                        setPaginationModel((prev) => ({ ...prev, pageSize }))
                    }}
                    sortingMode='server'
                    onSortModelChange={(model) => {
                        setOrderModel((prev) => model && model.length > 0 ? model[0] : null);
                        setPaginationModel(prev => { return { ...prev, page: 0 } });
                    }}
                    disableColumnFilter
                    sx={{
                        ".MuiDataGrid-columnHeaders": {
                            background: colors.blueAccent[700]
                        },
                        ".MuiDataGrid-footerContainer": {
                            background: colors.blueAccent[700]
                        },
                        ".MuiDataGrid-toolbarContainer .MuiButton-text": {
                            color: colors.grey[100]
                        }
                    }}
                />
            </Box>
        </Box>
    )
}

export default CouponOwners;